import { staffApi } from '@/services/staff-service'

export const queryDuty = (query = {}) => {
  return staffApi
    .get('odata/duty/', {
      params: {
        ...query
      }
    })
    .then(({ data }) => data.value)
    .catch(() => [])
}
